//TOAST UTILIZADO PARA INFORMAMOS ALTERAÇÃO DE STATUS
import { Toast, ToastContainer } from "react-bootstrap";
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle } from "react-icons/fa";
import "./NotificationToast.css";

const NotificationToast = ({ show, onClose, message, type }) => {
  const getToastVariant = () => {
    switch (type) {
      case "success":
        return "notification-toast--success";
      case "error":
        return "notification-toast--error";
      case "warning":
        return "notification-toast--warning";
      default:
        return "notification-toast--info";
    }
  };

  const getIcon = () => {
    switch (type) {
      case "success":
        return <FaCheckCircle aria-hidden />;
      case "error":
        return <FaExclamationCircle aria-hidden />;
      case "warning":
        return <FaExclamationCircle aria-hidden />;
      default:
        return <FaInfoCircle aria-hidden />;
    }
  };

  return (
    <ToastContainer
      className="position-fixed top-0 end-0 p-3 notification-toast-container"
      style={{ zIndex: 9999 }}
    >
      <Toast
        onClose={onClose}
        show={show}
        delay={5000}
        autohide
        className={`notification-toast ${getToastVariant()}`}
      >
        <Toast.Body className="notification-toast__body">
          <span className="notification-toast__icon">{getIcon()}</span>
          <span className="notification-toast__message">{message}</span>
          <button
            onClick={onClose}
            aria-label="close"
            className="btn-close notification-toast__close ms-2"
          ></button>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default NotificationToast;
